@for (breadcrumb of breadcrumbs; track breadcrumb) {
    <a class="truncate" [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">
        @if (breadcrumb.alias) {
            {{ breadcrumb.label }}
        } @else {
            {{ breadcrumb.label | translate }}
        }
    </a>
}
